module.exports = __webpack_public_path__ + "static/media/icon_warning_summary.be7b202c.svg";